import React, { memo } from "react";
import { HashLink } from "react-router-hash-link";
import { Helmet } from "react-helmet-async";
import logo from "../images/logo-removebg-preview.png";
import Collapse from "bootstrap/js/dist/collapse";
import { useTranslation } from "react-i18next";
import BtnChangLang from "./ChangeLang";

function Navbar() {
  const { t, i18n } = useTranslation();
  const navbarHeight = 90;

  const dir = i18n.language === "ar" ? "rtl" : "ltr";

  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = yCoordinate - navbarHeight;
    window.scrollTo({ top: yOffset, behavior: "smooth" });
  };

  const navItems = [
    { label: t("nav.home"), to: "/#home" },
    { label: t("nav.about"), to: "/#about" },
    { label: t("nav.services"), to: "/#services" },
    { label: t("nav.team"), to: "/#team" },
    { label: t("nav.activities"), to: "/#activities" },
    {
      label: t("nav.reviews"),
      to: "/reviews",
    },
    { label: t("nav.articles"), to: "/articles" },
    { label: t("nav.contact"), to: "/#contact" },
  ];

  const closeMenu = () => {
    const navbar = document.getElementById("navbarSupportedContent");
    if (navbar) {
      const bsCollapse = Collapse.getOrCreateInstance(navbar);
      bsCollapse.hide();
    }
  };

  return (
    <>
      <Helmet htmlAttributes={{ dir }}>
        <title>{t("nav.home")} | مركز سليم سمايل – رام الله</title>
        <meta
          name="description"
          content="مركز سليم سمايل في رام الله يقدم خدمات شاملة في طب وتجميل الأسنان باستخدام أحدث التقنيات وفريق متخصص لابتسامة صحية وجميلة."
        />
      </Helmet>

      <div dir={dir}>
        <nav
          className="navbar navbar-expand-lg navbar-light fixed-top py-1 bg-blur"
          style={{
            background: "rgba(255, 255, 255, 0.82)",
            backdropFilter: "blur(10px) saturate(120%)",
            WebkitBackdropFilter: "blur(10px) saturate(120%)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            boxShadow: "0 6px 24px rgba(16,24,40,0.08)",
          }}
        >
          <div className="container d-flex justify-content-between align-items-center">
            <HashLink
              smooth
              to="/#home"
              scroll={scrollWithOffset}
              className="navbar-brand d-lg-none"
              onClick={closeMenu}
            >
              <img
                src={logo}
                alt="شعار مركز سليم سمايل"
                width="50"
                height="50"
                loading="lazy"
              />
            </HashLink>
            <div className="d-flex align-items-center d-lg-none">
              <BtnChangLang />
              <button
                className="navbar-toggler ms-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            </div>

            <div
              className={`collapse navbar-collapse ${
                dir === "rtl" ? "me-auto" : "ms-auto"
              }`}
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav mb-2 mb-lg-0 d-flex align-items-center gap-lg-2">
                {navItems.map((item, index) => (
                  <li className="nav-item" key={index}>
                    {item.external ? (
                      <a
                        className="nav-link fs-5"
                        href={item.href}
                        style={{ color: "#00ACE7" }}
                        onClick={closeMenu}
                      >
                        {item.label}
                      </a>
                    ) : (
                      <HashLink
                        smooth
                        to={item.to}
                        scroll={scrollWithOffset}
                        className="nav-link fs-5"
                        style={{ color: "#00ACE7" }}
                        onClick={closeMenu}
                      >
                        {item.label}
                      </HashLink>
                    )}
                  </li>
                ))}

                <li className="nav-item d-none d-lg-block">
                  <BtnChangLang />
                </li>
              </ul>
            </div>
            {/* Logo */}
            <HashLink
              smooth
              to="/#home"
              scroll={scrollWithOffset}
              className="navbar-brand d-none d-lg-block"
              onClick={closeMenu}
            >
              <img
                src={logo}
                alt="شعار مركز سليم سمايل"
                width="50"
                height="50"
                loading="lazy"
              />
            </HashLink>
          </div>
        </nav>
      </div>
    </>
  );
}

export default memo(Navbar);
